import { render, staticRenderFns } from "./popupBlock.vue?vue&type=template&id=4e86e29e&scoped=true"
import script from "./popupBlock.vue?vue&type=script&lang=js"
export * from "./popupBlock.vue?vue&type=script&lang=js"
import style0 from "./popupBlock.vue?vue&type=style&index=0&id=4e86e29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e86e29e",
  null
  
)

export default component.exports